import { createSelector } from 'reselect'

const getExternalAccountByProvider = (accounts, provider, team = false) => accounts.find(account => !account.sso && account.provider === provider && account.team === team);
export const makeGetExternalAccountByProvider = () => createSelector(getExternalAccountByProvider, account => account);

const getExternalAccounts = (accounts, team = false) => accounts.filter(account => !account.sso && account.team === team);
export const makeGetExternalAccounts = () => createSelector(getExternalAccounts, accounts => accounts);

const getExternalSSOAccounts = accounts => accounts.filter(account => account.sso);
export const makeGetExternalSSOAccounts = () => createSelector(getExternalSSOAccounts, accounts => accounts);
